const INVALID_STORAGE_VALUES = new Set(['', 'null', 'undefined'])
const MEMBER_TOKEN_KEY = 'memberToken'
const MEMBER_INFO_KEY = 'memberInfo'
const MEMBER_SESSION_EXPIRES_AT_KEY = 'memberSessionExpiresAt'
export const MEMBER_SESSION_DURATION_MS = 7 * 24 * 60 * 60 * 1000

function normalizeStoredValue(value) {
  if (value == null) {
    return ''
  }

  const normalized = String(value).trim()
  return INVALID_STORAGE_VALUES.has(normalized) ? '' : normalized
}

function getSessionExpiresAt() {
  const expiresAt = Number(localStorage.getItem(MEMBER_SESSION_EXPIRES_AT_KEY) || 0)
  return Number.isFinite(expiresAt) ? expiresAt : 0
}

function writeSessionExpiresAt() {
  localStorage.setItem(MEMBER_SESSION_EXPIRES_AT_KEY, String(Date.now() + MEMBER_SESSION_DURATION_MS))
}

export function saveMemberToken(token) {
  const normalized = normalizeStoredValue(token)
  if (!normalized) {
    return
  }
  localStorage.setItem(MEMBER_TOKEN_KEY, normalized)
  writeSessionExpiresAt()
}

export function saveMemberInfo(memberInfo) {
  if (!memberInfo) {
    return
  }
  localStorage.setItem(MEMBER_INFO_KEY, JSON.stringify(memberInfo))
}

export function clearMemberSession() {
  localStorage.removeItem(MEMBER_TOKEN_KEY)
  localStorage.removeItem(MEMBER_INFO_KEY)
  localStorage.removeItem(MEMBER_SESSION_EXPIRES_AT_KEY)
}

export function getMemberToken() {
  const token = normalizeStoredValue(localStorage.getItem(MEMBER_TOKEN_KEY))
  if (!token) {
    clearMemberSession()
    return ''
  }

  const expiresAt = getSessionExpiresAt()
  if (!expiresAt) {
    writeSessionExpiresAt()
    return token
  }

  if (expiresAt <= Date.now()) {
    clearMemberSession()
    return ''
  }

  return token
}

export function hasMemberSession() {
  return Boolean(getMemberToken())
}
